import { Button } from '@mui/material';
import { useSnackbar } from 'notistack';

const NotificationBarAction = function (notificationId) {
    const { closeSnackbar } = useSnackbar();
    return (
        <Button
            sx={{
                color: '#e37444',
            }}
            onClick={() => closeSnackbar(notificationId)}
        >
            Dismiss
        </Button>
    );
};

export default NotificationBarAction;
